import { Grid, Typography, Button } from "@mui/material";
import Section from "../../../../components/section/section";
import AttachmentIcon from "@mui/icons-material/Attachment";
import transformDateToDe from "../../../../functions/transformDateToDe";
import NoParticipantsFound from "./noParticipantsFound";
import AppointmentList from "./appointmentList";
import React from "react";
import { BookingOverviewContext } from "../context/bookingOverviewContext";
import {
  ParticipantData,
  SearchCriteria,
} from "../interface/bookingOverviewInterface";

const UserDataView = (): React.JSX.Element => {
  const {
    participantData,
    setShowFileDialog,
    searchCriteria,
  }: {
    participantData: ParticipantData[] | null;
    setShowFileDialog: (showFileDialog: {
      open: boolean;
      participant: ParticipantData | null;
    }) => void;
    searchCriteria: SearchCriteria;
  } = React.useContext(BookingOverviewContext);

  const getFilteredParticipants = (): ParticipantData[] =>
    participantData !== null
      ? participantData.filter(
          (participant) =>
            (searchCriteria.status.active && participant.status === 0) ||
            (searchCriteria.status.inactive && participant.status === 1)
        )
      : [];

  return (
    <Section>
      {participantData !== null && participantData.length === 0 && (
        <NoParticipantsFound />
      )}

      {getFilteredParticipants().map((participant) => {
        return (
          <Grid
            key={participant.participantId}
            container
            rowSpacing={2}
            sx={{
              borderLeft: "15px solid",
              borderRight: "15px solid",
              borderColor:
                participant.status === 0
                  ? (theme) => theme.palette.success.light
                  : (theme) => theme.palette.error.light,

              backgroundColor: (theme) => theme.palette.grey[100],
              borderRadius: 2,
              mb: 4,
              p: 2,
            }}
          >
            <Grid item xs={12} sm={6} lg={4}>
              <Typography
                sx={{
                  fontWeight: "bold",
                }}
                variant="caption"
                component="p"
              >
                Teilnehmer:in
              </Typography>
              <Typography variant="body1" component="p">
                {participant.fullName}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} lg={4}>
              <Typography
                sx={{
                  fontWeight: "bold",
                }}
                variant="caption"
                component="p"
              >
                Qualifizierung
              </Typography>
              <Typography variant="body1" component="p">
                {participant.qualification}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} lg={4}>
              <Typography
                sx={{
                  fontWeight: "bold",
                }}
                variant="caption"
                component="p"
              >
                Email
              </Typography>
              <Typography
                variant="body1"
                component="p"
                sx={{
                  wordBreak: "break-all",
                }}
              >
                {participant.email}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} lg={4}>
              <Typography
                sx={{
                  fontWeight: "bold",
                }}
                variant="caption"
                component="p"
              >
                Telefonnummer
              </Typography>
              <Typography
                variant="body1"
                component="p"
                sx={{
                  wordBreak: "break-all",
                }}
              >
                {participant.phoneNumber}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} lg={4}>
              <Typography
                sx={{
                  fontWeight: "bold",
                }}
                variant="caption"
                component="p"
              >
                Zeitraum
              </Typography>
              <Typography variant="body1" component="p">
                {`${transformDateToDe(
                  participant.startOfQualification
                )} bis ${transformDateToDe(participant.endOfQualification)}`}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} lg={4}>
              <Typography
                sx={{
                  fontWeight: "bold",
                }}
                variant="caption"
                component="p"
              >
                Unterlagen
              </Typography>
              <Button
                onClick={() =>
                  setShowFileDialog({
                    open: true,
                    participant,
                  })
                }
                startIcon={<AttachmentIcon />}
                variant="contained"
                color="secondary"
                size="small"
                disabled={participant.files.meta.total === 0}
              >
                {participant.files.data.length > 0
                  ? "Ansehen"
                  : "Keine Unterlagen vorhanden"}
              </Button>
            </Grid>

            <Grid item xs={12} sm={6} lg={4}>
              <Typography
                sx={{
                  fontWeight: "bold",
                }}
                variant="caption"
                component="p"
              >
                Status
              </Typography>
              <Typography variant="body1" component="p">
                {participant.status === 0 ? "Aktiv" : "Inaktiv"}
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <AppointmentList participant={participant} />
            </Grid>
          </Grid>
        );
      })}
    </Section>
  );
};

export default UserDataView;
